import Vue from 'vue'
import Vuex from 'vuex'
import router from './router'
const fb = require('@/firebaseConfig.js')

Vue.use(Vuex);

export const store = new Vuex.Store({

    state: {
        currentUser: null,
        userProfile: {},
        users: [],
    },
    actions: {
        fetchUserProfile({ commit, state }) {
            fb.usersCollection.where('email', '==', state.currentUser.email).get().then(querySnapshot => {
                    let res = querySnapshot.docs[0];
                    console.log("res: ", res)
                        // check for admin role
                    let roles = res.data().roles;
                    console.log("rollen: " + roles);
                    if (!roles || (!roles.includes("admin") && !roles.includes("superAdmin"))) {
                        fb.auth.signOut().then(() => {
                            store.dispatch('clearData');
                            router.push('/noaccess');
                        });
                        throw "geen rechten";
                    } else {
                        Vue.$cookies.set('company', res.data().company)
                        Vue.$cookies.set('user', res.data().firstname + " " + res.data().lastname)
                        commit('setUserProfile', res.data())
                    }

                })
                .catch(err => {
                    console.log(err)
                })
        },
        clearData({ commit }) {
            commit('setCurrentUser', null)
            commit('setUserProfile', {})
            commit('setUsers', null)
        }
    },
    mutations: {
        setCurrentUser(state, val) {
            state.currentUser = val
        },
        setUserProfile(state, val) {
            state.userProfile = val
            state.company = val.company
        },
        setUsers(state, val) {
            state.users = val;
        },
    }

})
fb.auth.onAuthStateChanged(user => {
    if (user) {
        store.commit('setCurrentUser', user)
        store.dispatch('fetchUserProfile')
    } else {
        Vue.$cookies.set('company', "")
    }
})